import { UserSquare } from "@mynaui/icons-react";
import Icon from '@mdi/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenFancy } from '@fortawesome/free-solid-svg-icons';
import { mdiChartBoxOutline } from '@mdi/js';
import {CalendarMention20Regular , Payment20Regular} from '@fluentui/react-icons';
import { AiOutlineFileDone } from "react-icons/ai";
import { MdCancel, MdOutlinePendingActions } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import { FiBookOpen, FiCalendar, FiFilePlus, FiMessageSquare, FiUser } from "react-icons/fi";
import { MdTimer } from "react-icons/md";
import { HiMiniHandRaised } from "react-icons/hi2";
import { Contact02Icon } from 'hugeicons-react';
import { IoMdInformationCircleOutline } from "react-icons/io";
import { LuCalendarClock } from "react-icons/lu";


import { coursesEnabled } from "./courseFeatures";

export const sideBarOptions = [
    {
        title: "Dashboard",
        icon: <BiHomeAlt style={{ width: "20px", height: "20px" }} />,
        link: "/"
    },
    {
        title: "Place Order",
        icon: <FiFilePlus style={{ width: "20px", height: "20px" }} />,
        link: "/calculation"
    },
    {
        title: "Messages",
        icon: <FiMessageSquare style={{ width: "20px", height: "20px" }} />,
        link: "/messages",
        showUnreadBadge: true,
    },
    ...(coursesEnabled ? [{
        title: "My Courses",
        icon: <FiBookOpen style={{ width: "20px", height: "20px" }} />,
        link: "/courses",
        showCourseUnreadBadge: true,
    }] : []),
    {
        title: "In Progress",
        icon: <MdOutlinePendingActions style={{ width: "20px", height: "20px" }} />,
        link: "/in-progress",
        showInProgressBadge: true,
    },
    {
        title: "All Orders",
        icon: <FiCalendar style={{ width: "20px", height: "20px" }} />,
        childs: [
            { title: "Drafts", link: "/pending-orders" },
            { title: "Completed", link: "/raise-complaint" },
            { title: "Cancelled", link: "/cancelled-orders" },
            { title: "View All Orders", link: "/my-orders" },
        ],
    },
    {
        title: "My Account",
        icon: <FiUser style={{ width: "20px", height: "20px" }} />,
        childs: [
            { title: "Profile", link: "/edit-profile" },
            { title: "Wallet", link: "/my-wallet" },
            { title: "Earnings", link: "/referrals" },
            { title: "Loyalty Rewards", link: "/loyalty-rewards" },
            { title: "Logout", isLogout: true },
        ],
    },
    {
        title: "Terms and Conditions",
        icon: <IoMdInformationCircleOutline style={{ width: "20px", height: "20px" }} />,
        link: "/terms-and-conditions"
    },
    {
        title: "Privacy Policy",
        icon: <IoMdInformationCircleOutline style={{ width: "20px", height: "20px" }} />,
        link: "/privacy-policy"
    },
];
